export const clientHeaders = {
  deviceId: "x-cpj-device-id",
  jwtPrefix: "Bearer",
};
